import React from 'react';

import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { cssMap } from '@atlaskit/css';

import { useAudioBriefing } from '../../../../hooks/useAudioBriefing';

import { AdditionalResourceSelection } from './sub-components/AdditionalResourceSelection';
import { RestartButton } from './sub-components/RestartButton';
import { BriefingSourcesInput } from './sub-components/BriefingSourcesInput';

const styles = cssMap({
	container: {
		flex: 1,
	},
	textFieldContainer: {
		flexGrow: 1,
		paddingBlock: token('space.negative.400'),
	},
	restartButtonContainer: {
		marginBlockStart: token('space.150'),
	},
});

export type ResolvedAtlassianLink = {
	ari: string;
	product: string;
	resourceType: string;
};

export const AudioBriefingPopupSourcesPanel = () => {
	const [
		{
			activeContent,
			additionalResources,
			cloudId,
			hasFetched,
			isLoading,
			lastGeneratedBriefingConfig,
		},
		{ addAdditionalResource, removeAdditionalResource, fetchBriefing },
	] = useAudioBriefing();

	const { additionalResources: lastGeneratedAdditionalResources } =
		lastGeneratedBriefingConfig || {};

	return (
		<Box xcss={styles.container}>
			<Stack space="space.075">
				{additionalResources.map((resource) => (
					<AdditionalResourceSelection
						key={resource.url}
						resource={resource}
						removeResource={removeAdditionalResource}
					/>
				))}
			</Stack>
			<Box xcss={styles.textFieldContainer}>
				<BriefingSourcesInput
					cloudId={cloudId}
					additionalResources={additionalResources}
					addAdditionalResource={addAdditionalResource}
					activeContent={activeContent}
				/>
			</Box>
			{hasFetched && (
				<Box xcss={styles.restartButtonContainer}>
					<RestartButton
						fetchBriefing={fetchBriefing}
						currentAdditionalResources={additionalResources}
						isLoading={isLoading}
						lastGeneratedAdditionalResources={lastGeneratedAdditionalResources}
					/>
				</Box>
			)}
		</Box>
	);
};
